export default __webpack_public_path__ + "assets/png/4b0fa05b8ef4b473fa148b6aa7308174.png";